import type { PlacementDragGhostProps } from '../types/placement-drag-ghost-props'

/**
 * The ghost's top-left corner, in client coordinates:
 * - flyback: centred over the tray thumbnail it came from
 * - keyboard carry: centred horizontally on that thumbnail, floating 8px above it
 * - pointer drag: centred on the pointer
 */
export function dragGhostPosition({
  clientX,
  clientY,
  width,
  height,
  keyboardCarry,
  flyback,
  thumbOrigin,
}: Pick<
  PlacementDragGhostProps,
  'clientX' | 'clientY' | 'width' | 'height' | 'keyboardCarry' | 'flyback' | 'thumbOrigin'
>): { left: number; top: number } {
  if (flyback) {
    return {
      left: thumbOrigin.left + thumbOrigin.width / 2 - width / 2,
      top: thumbOrigin.top + thumbOrigin.height / 2 - height / 2,
    }
  }

  if (keyboardCarry) {
    return {
      left: thumbOrigin.left + thumbOrigin.width / 2 - width / 2,
      top: thumbOrigin.top - height - 8,
    }
  }

  return { left: clientX - width / 2, top: clientY - height / 2 }
}
